import { refiner } from '@/plugins/refiner';

export const initRefiner = ({ userUid, userProfile }) => {
  refiner.setProject(import.meta.env.VITE_REFINER_PROJECT_ID);
  refiner.identifyUser({ userUid, userProfile });
};
